import { render } from "./AppointmentNotesSection.vue?vue&type=template&id=0da88380"
import script from "./AppointmentNotesSection.vue?vue&type=script&lang=js"
export * from "./AppointmentNotesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__